import module from '../module';

export class ChangePasswordController {
    static $inject = [ '$scope', '$mdDialog', 'AuthenticationService', 'Message' ];
    static controllerName = 'ChangePasswordController';

    constructor($scope, $mdDialog, authenticationService, messageService) {

        $scope.inProgress = false;
        $scope.errorMessage = '';

        $scope.data = {
            password: '',
            oldPassword: ''
        };

        $scope.cancel = () => {
            $mdDialog.cancel();
        };

        $scope.changePassword = async (form) => {

            $scope.errorMessage = '';

            if (form.$invalid) {
                form.highlightAllErrors();
                return;
            }

            $scope.inProgress = true;

            return authenticationService.changePassword($scope.data.oldPassword, $scope.data.password).then(() => {
                return $mdDialog.hide();
            }, (error) => {
                $scope.errorMessage = messageService.getMessageFromErrorResponse(error);
            }).finally(() => {
                $scope.inProgress = false;
            });
        };
    }
}

module.controller(ChangePasswordController.controllerName, ChangePasswordController);



// WEBPACK FOOTER //
// ./src/modules/shared/controllers/ChangePasswordController.js